module.exports = __webpack_public_path__ + "static/integrately-10ced62f1dd1d28ce9556e53f942704c.svg";